var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"myQuillEditor",class:[!_vm.error || 'err', !_vm.$vuetify.dark || 'white--text' ],attrs:{"options":{
		placeholder: 'Escribe aquí el mensaje...',
		modules: {
			toolbar: _vm.toolbarOptions,
		},
	}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }